import { Address } from './types/Address';
import { SocialMediaLinks } from './types/SocialMediaLinks';
import { GasEngineer } from './types/GasEngineer';
import { Contact } from './types/Contact';
import { Membership } from './types/Membership';
import { CurrentProduct } from './types/CurrentProduct';
import { LocalAuthority } from './types/LocalAuthority';
import { Permissions } from './types/Permissions';
import { MemberContextRoot } from './types/MemberContextRoot';
import { DateTimeString } from '../../../models/BrandedTypes';
import { Benefit } from './types/Benefit';
import { PaymentType } from './types/PaymentType';
import { Title } from './types/Title';
import { Type } from './types/Type';
import { IdName } from './types/IdName';
import { Invoice } from './types/Invoice';
import { Transaction } from './types/Transaction';

export const defaultAddress: Address = {
  line1: '',
  line2: '',
  line3: '',
  town: '',
  postCode: '',
  county: '',
  shortAddress: '',
  longAddress: '',
};

export const defaultIdName: IdName = {
  id: '',
  name: '',
};

export const defaultType: Type = {
  value: 0,
  text: '',
};

export const defaultTitle: Title = {
  text: '',
  value: 0,
};

export const defaultPaymentType: PaymentType = {
  id: '',
  name: '',
  bankAccountRequired: null,
  isCardPayment: false,
  isContinuousPayment: null,
};

export const defaultBenefit: Benefit = {
  id: '',
  item: { ...defaultIdName },
  maximum: 0,
  quantityUsed: 0,
  quantityRemaining: 0,
  membershipId: '',
  type: { ...defaultType },
  classification: { ...defaultIdName },
};

export const defaultContact: Contact = {
  id: '',
  titleAsString: '',
  title: { ...defaultTitle },
  fullName: '',
  firstName: '',
  middleName: null,
  lastName: '',
  email: '',
  businessPhone: '',
  homePhone: null,
  mobilePhone: '',
  workAddress: { ...defaultAddress },
  doNotAllowEmails: false,
  doNotAllowPhoneCalls: false,
  salutation: '',
  isNew: false,
};

export const defaultCurrentProduct: CurrentProduct = {
  id: '',
  name: '',
  productCode: '',
  isCpa: false,
};

export const defaultGasEngineer: GasEngineer = {
  id: '',
  name: '',
  mainPhone: '',
  website: null,
};

export const defaultLocalAuthority: LocalAuthority = {
  id: '',
  text: '',
};

export const defaultMembership: Membership = {
  id: '',
  name: '',
  automaticallyRenew: false,
  endDate: '' as DateTimeString,
  startDate: '' as DateTimeString,
  status: '',
  invoiceRef: '',
  productId: '',
  productName: '',
  unitId: '',
  unit: '',
  membershipType: '',
  membershipSubType: '',
  paymentType: { ...defaultPaymentType },
  intentionToRenew: null,
};

export const defaultPermissions: Permissions = {
  workOps: '',
  sendCompanyDocuments: '',
  riskAssessments: '',
  companyDocuments: '',
  tradingUnits: '',
  training: '',
  rewards: '',
  wallet: '',
};

export const defaultSocialMediaLinks: SocialMediaLinks = {
  twitter: '',
  instagram: '',
  facebook: '',
  tikTok: '',
  youtube: '',
  linkedin: '',
  website: '',
};

export const defaultTransaction: Transaction = {
  id: "",
  amount: 0,
  dueDate: undefined,
  status: "",
  receiptDate: undefined,
  cardLastFourDigits: undefined,
  cardExpiry: undefined,
  paymentMethod: "",
  isOverdue: false,
};

export const defaultInvoice: Invoice = {
  id: "",
  invoiceNumber: "",
  type: "",
  currency: "",
  status: "",
  name: "",
  description: null,
  amount: 0,
  tax: 0,
  paid: 0,
  outstanding: 0,
  overdue: 0,
  discountAmount: 0,
  date: "",
  transactions: [{ ...defaultTransaction }],
  overdueTransactionIds: [],
};

export const defaultMemberContextRoot: MemberContextRoot = {
  benefits: [],
  permissions: { ...defaultPermissions },
  id: '',
  tradingName: '',
  membershipNumber: '',
  mainPhone: '',
  balance: 0,
  numberOfTradingUnits: 0,
  companyTypeId: 0,
  vatRegistered: false,
  companyRegistrationOrCharityNumber: '',
  missedPayments: 0,
  referralCode: '',
  mailingAddress: { ...defaultAddress },
  invoiceAddress: { ...defaultAddress },
  socialMediaLinks: { ...defaultSocialMediaLinks },
  gasEngineerId: '',
  gasEngineer: { ...defaultGasEngineer },
  primaryContact: { ...defaultContact },
  additionalContacts: [],
  latestMembership: { ...defaultMembership },
  currentProduct: { ...defaultCurrentProduct },
  previousMemberships: [],
  foodHygieneRatingUrl: '',
  localAuthority: { ...defaultLocalAuthority },
  invoice: {...defaultInvoice},
  hasOutstandingBalance: false,
  hasFreeTrialUnits: false
};